import React, { useState, useEffect, Fragment, useMemo } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import CustomerListTable from "../customer/CustomerListTable";
import SideBar from "../Dashboard/SideBar";

import {
  useFetchUserDataTableDataQuery,
  useLazyUpdateUserActiveGetQuery,
} from "../../utils/customer/customerTaskTable";
import UserHeader from "./UserHeader";
import AddUserModal from "./AddUserModal";
import HeaderDashboard from "../HeaderDashboard";
import { parseJSONValue } from "../../utils/json/parseJSONValue";
import UserPageDetails from "../GlobalFeature/Others/UserPageDetails";
import Tooltip from "@mui/material/Tooltip";
import UserProfileView from "./UserProfileView";
import { Drawer, FormControl, MenuItem, Select } from "@mui/material";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import { UserActiveFilters, UserTypeFilters } from "./UserFilters";
import DeleteIcon from "../../assets/images/icons/deleteIcon";
import CreatePortalHOC from "../GlobalFeature/Fields/CreatePortalHOC";
import UserHoverDetails from "./UserHoverDetails";
import MuiLoader from "../GlobalFeature/Loader/MuiLoader";
import { ReactComponent as ExpandCollapsIMG } from "../../assets/images/expandCollapsIMG.svg";
import { ReactComponent as ActiveIcon } from "../../assets/images/handleToggleUserActiveIcon.svg";
import { ReactComponent as InActiveIcon } from "../../assets/images/handleToggleUserActiveIcon copy.svg";
import Loader from "../UniversalComponents/Loader";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import ActiveFilterComponent from "../UniversalComponents/ActiveFilterComponent";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import { getInitials, getTitleCase } from "../../utils/utilityFunctions/stringUtility";
import UserNameHover from "./UserNameHover";
import CustomerShowDetails from "../customer/CustomerShowDetails";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import { ReactComponent as NoUSerManagement } from "../../assets/images/NoUserManagement.svg";

const UserPage = () => {
  const [quiFilter, setQuiFilter] = useState({ external: 0, status: 1 });
  const [customerTablePagination, setCustomerTablePagination] = useState("");
  const [customer, setCustomer] = useState([]);
  const [initialFilter, setInitialFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const { token } = useRequireAuth();
  //const [isUEModalOpen, setisUEModalOpen] = useState(false);
  const [SelecteduserId, setSelecteduserId] = useState(null);
  //const openUEModal = () => setisUEModalOpen(true);
  //const closeUEPopup = () => setisUEModalOpen(false);
  const [ticker, setTicker] = useState(0);

  const [editData, setEditData] = useState();
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [isProfileView, setIsProfileView] = useState(false);
  const [newDialog, setNewDialog] = useState(false);
  const [showHoverId, setShowHoverId] = useState(null);
  const [openShowDetails, setOpenShowDetails] = useState(false);
  // const [activeUserFlag,setActiveUserFlag]=useState(true)
  // const [externalUserFlag,setExternalUserFlag]=useState(false)
  const [isHovered, setIsHovered] = useState(false);
  const [isPermissionOpen, setIsPermissionOpen] = useState(false);

  const keysToExclude = [
    "userId",
    "enabled_status",
    "manager_designation",
    "action",
    "useruuId",
    "reporting_uuid",
    "company",
  ];
  const dispatch = useDispatch();

  const handleToggle = () => {
    setIsProfileView(!isProfileView);
  };

  const {
    data: customerTableALL,
    refetch: refetchCustomerData,
    isLoading,
    isError: isUserDataError,
  } = useFetchUserDataTableDataQuery({
    pagination: `${customerTablePagination}`,
    quiFilter: quiFilter,
    token: token,
  });

  //update the active/inActive
  const [
    updateUserActive,
    { isLoading: isUpdating, isSuccess: isUpdateSuccess, isError: isUpdateError, error: updateError },
  ] = useLazyUpdateUserActiveGetQuery();

  useEffect(() => {
    handelsave();
  }, [quiFilter]);
  const totalData = customerTableALL?.data?.total;

  const handleNavigate = (userData) => {
    setIsPopupOpen(true);
    setEditData(userData);
    setSelecteduserId(userData.userUuid);
  };

  const handleNavigateMore = (...data) => {
    setEditData(data);
    setOpenShowDetails(true);
    // console.log(data, "DATAvinay");
  };

  const createColumnDefinitions = (data, handleNavigate, handleNavigateMore) => {
    if (!Array.isArray(data) || data.length === 0) {
      console.error("Invalid data provided");
      return [];
    }

    // Extract the first object
    const firstObject = data[0];

    // Get all keys and exclude the first and last keys
    //const keys = Object.keys(firstObject).slice(1, -1);
    const keys = Object.keys(firstObject)
      .filter((key) => !keysToExclude.includes(key))
      .slice(1);

    // console.log(keys, "keys");

    // Map over the keys to create column definitions
    return keys.map((key, index) => ({
      accessor_key: key,
      label: getTitleCase(key),
      ...((key === "user_name" || key === "reporting") && {
        callingFunction: handleNavigate,
        tooltip: UserNameHover,
        toolTipHandler: handleNavigateMore,
        titleCase: true,
      }), // Add callingFunction only to the first column
    }));
  };

  const ManageListHeader = createColumnDefinitions(customer, handleNavigate, handleNavigateMore);
  const memoizedData = useMemo(() => customerTableALL?.data?.data || [], [customerTableALL]);

  useEffect(() => {
    if (customerTableALL) {
      const { data, ...restData } = customerTableALL?.data;
      setCustomer(memoizedData);
      setInitialFilter(restData);
      setLoading(false);
    }
  }, [customerTableALL, customerTablePagination, refetchCustomerData]);

  const closePopup = () => {
    setEditData();
    setIsEditPopupOpen(false);
    setIsPopupOpen(false);
    setNewDialog(false);
  };
  const handelsave = () => {
    refetchCustomerData();
  };

  const openPopup = () => {
    setSelecteduserId(null);
    setIsPopupOpen(true);
  };

  useEffect(() => {
    if (!isPopupOpen) {
      setIsHovered(false);
    }
  }, [isPopupOpen]);
  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };

  const handleOpenNewDialog = () => {
    setNewDialog(true);
  };

  const ProfileOutSideClick = useClickOutside(() => {
    setIsEditPopupOpen(false);
  });

  const handleToggleUserActive = async (data) => {
    // console.log(data?.userId, "vinaydata");

    try {
      await updateUserActive({ token, data: data?.userId });
      refetchCustomerData();
      dispatch(pushAlert({ message: "User updated successfully!", type: "success", visible: true }));
    } catch (err) {
      dispatch(pushAlert({ message: "Something went wrong.", type: "error", visible: true }));
    }
  };

  const handleActiveChange = (e) => {
    setQuiFilter({ ...quiFilter, status: e.target.value });
  };

  const handleTypeChange = (e) => {
    setQuiFilter({ ...quiFilter, external: e.target.value });
  };

  const handleShowHover = (data, header) => {
    setShowHoverId({ data, header });
  };

  const handleShowDetails = (value, headerKey) => {
    setOpenShowDetails(value && { customerData: value, headerKey });
  };

  const isHoverDetailsOpen = (item, header) => {
    const customerIdMatches = showHoverId?.data?.customer_id?.value === item?.customer_id?.value;
    const headerKeyMatches = showHoverId?.header?.key === header?.key;

    return customerIdMatches && headerKeyMatches;
  };

  const handleEditModalClick = (userId) => {
    setSelecteduserId(userId);
  };
  const closeUEPopup = () => {
    setSelecteduserId(null);
  };

  useEffect(() => {
    if (isLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isLoading]);

  return (
    <div className="flex flex-col gap-1 h-full justify-around ">
      <Loader isOpen={isUpdating} />
      <HeaderDashboard />
      <div class="flex gap-5 px-2 grow min-h-0 box-border">
        <div className="w-2/12">
          <SideBar />
        </div>

        <div className="flex flex-col grow min-h-0 h-full">
          <ReactTableComponent
            apiStates={{
              body: {
                isLoading: isLoading,
                isError: isUserDataError,
              },
            }}
            alternateDivs={{
              emptyData: (
                <div className="w-full h-full">
                  <div className="flex justify-center items-center flex-col space-y-2 h-full ">
                    <NoUSerManagement className="h-[300px] w-[300px]" />
                    <span className="text-14 text-black text-sm font-400 font-poppins ">
                      No User Management External User Data is Available.
                    </span>
                    {/* <span
                             onClick={() => openPopup()}
                             className="border px-5 py-1  bg-white cursor-pointer items-center text-center text-base font-medium  hover:border-[#1D4469] hover:text-[#1D4469] text-[#383838] rounded-md shadow-[0px_1px_0px_0px_rgba(0,0,0,0.10)_inset,0px_0px_4px_0px_rgba(0,0,0,0.15)]"
                           >
                             + Add Service
                           </span> */}
                  </div>
                </div>
              ),
            }}
            tablename={"All Users"}
            headers={ManageListHeader}
            body={customer}
            isProfilePodToolTip={true}
            refetchprofilePodTable={handelsave}
            onRowClick={(data) => console.log("userID kl", data)}
            actionField={
              <div className="flex gap-1 ">
                <ActiveFilterComponent
                  onChange={handleTypeChange}
                  value={quiFilter.external}
                  filters={UserTypeFilters}
                />
                <ActiveFilterComponent
                  onChange={handleActiveChange}
                  value={quiFilter.status}
                  filters={UserActiveFilters}
                />

                <button
                  onClick={openPopup}
                  type="button"
                  className=" border-[#EBF2F6] rounded-md  hover:border-transparent"
                >
                  <PlusIcon isHovered={isHovered} isActive={isPopupOpen} />
                </button>
              </div>
            }
            actionColumn={(item) => {
              // console.log("Itme itme item", item);
              return (
                <div
                  // className={m-1}
                  key={item?.id}
                >
                  <label className={`inline-flex cursor-pointer`}>
                    <input
                      key={item?.userId}
                      type={`checkbox`}
                      checked={Boolean(item?.enabled_status)}
                      value={item?.enabled_status}
                      className={`sr-only peer cursor-pointer`}
                      onClick={() => handleToggleUserActive(item)}
                    />
                    <div className={` ml-3`}>
                      <div className={`${Boolean(item?.enabled_status) ? "" : "rotate-180"}`}>
                        {Boolean(item?.enabled_status) ? <ActiveIcon /> : <InActiveIcon />}
                      </div>
                    </div>

                    {/* <button onClick={() => handleDeleteExternalUser(item)} className="ml-2 pt-2">
                      <DeleteIcon color={"red"} size={22} />
                    </button> */}
                  </label>
                  {/* <button className={`ms-3`} title="Edit" onClick={() => handleEditModalClick(item?.user.uuId)}>
                    <i className="bi bi-pencil"></i>
                  </button> */}
                </div>
              );
            }}
          />
        </div>
      </div>

      {isPopupOpen && (
        <AddUserModal
          open={isPopupOpen}
          closePopup={closePopup}
          handelsave={handelsave}
          title={SelecteduserId ? "Edit User" : "Add User"}
          editData={SelecteduserId}
          isPermissionOpen={isPermissionOpen}
          setIsPermissionOpen={setIsPermissionOpen}
        />
      )}

      {/* {openShowDetails && (
        <CustomerShowDetails open={openShowDetails} onClose={() => handleShowDetails(false)} Data={editData} enableEditButton={false} /> */}
      {/* )} */}

      {/* {isPopupOpen && <div> <CustomDrawer open={isPopupOpen} parallelDrawer> <div>isPopupOpen</div></CustomDrawer></div>} */}
    </div>
  );
};
export default UserPage;
